import { lang } from '@umu/ukit-lang';

import React, { Component } from 'react';
import './likeButton.scss';

interface IProps {
    onLike: (isLiked: boolean) => void;
    likeTotal: number;
    isLiked: boolean;
}

export default class LikeButton extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public onLikeClick = () => {
        const isLiked = !this.props.isLiked;
        this.props.onLike(isLiked);
    }

    public render() {
        const { isLiked } = this.props;
        const likeTotal = Math.max(this.props.likeTotal, 0);

        return (
            <div className="like-button">
                <div className="like-button-wrap">
                    <a
                        href="javascript:;"
                        className={`like-inner-wrap ${isLiked ? 'liked' : '' }`}
                        onClick={this.onLikeClick}
                    >
                        <span className="like-icon"></span>
                        {/*likeTotal前的空格不要删除*/}
                        <span className="like-num"> {likeTotal || lang('赞')}</span>
                    </a>
                </div>
            </div>
        );
    }
}


